import React from 'react';
import { useTranslation } from 'react-i18next';

const Pagination = ({ currentPage, totalPages, paginate, loading }) => {
  const pageNumbers = [];
  const { t } = useTranslation('header');

  // Ensure totalPages is at least 1
  const safeTotalPages = Math.max(1, totalPages);

  // Always show the first page and the last page
  if (currentPage > 2) {
    pageNumbers.push(1); // Always show the first page
  }

  // Add ellipsis if the current page is further away from the first page
  if (currentPage > 3) {
    pageNumbers.push('...');
  }

  // Show pages around the current page
  for (
    let i = Math.max(1, currentPage - 2);
    i <= Math.min(safeTotalPages, currentPage + 2);
    i++
  ) {
    // Don't add the first page again if it's already in the array
    if (i !== 1 || (i === 1 && !pageNumbers.includes(1))) {
      pageNumbers.push(i);
    }
  }

  // Add ellipsis if the current page is further away from the last page
  if (currentPage < safeTotalPages - 2) {
    pageNumbers.push('...');
  }

  // Always show the last page if it's not already included
  if (
    currentPage < safeTotalPages - 1 &&
    !pageNumbers.includes(safeTotalPages)
  ) {
    pageNumbers.push(safeTotalPages);
  }

  // If there's only one page, don't show pagination
  if (safeTotalPages <= 1) {
    return null;
  }

  return (
    <nav>
      <ul className="pagination">
        {currentPage > 1 && (
          <li className="page-item">
            <button
              className={`page-link ${loading ? 'disabled' : ''}`}
              onClick={() => paginate(currentPage - 1)}
              disabled={loading}
            >
              {t('PREVIOUS')}
            </button>
          </li>
        )}

        {pageNumbers.length > 1 &&
          pageNumbers.map((number, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === number ? 'active' : ''}`}
            >
              {number === '...' ? (
                <span className="page-link">...</span>
              ) : (
                <button
                  className={`page-link ${loading ? 'disabled' : ''}`}
                  onClick={() => paginate(number)}
                  disabled={currentPage === number || loading} // Disable button for current page
                >
                  {number}
                </button>
              )}
            </li>
          ))}

        {currentPage < safeTotalPages && (
          <li className="page-item">
            <button
              className={`page-link ${loading ? 'disabled' : ''}`}
              onClick={() => paginate(currentPage + 1)}
              disabled={loading}
            >
              {t('NEXT')}
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
